
export const prestataires = [
    {
      "idPrestataire":1,
      "firstName":"Julie",
      "job":"Femme de ménage",
      "rate":4.58,
      "nbReviews":159,
      "hourlyPrice":25,
      "imgProfile":"/assets/profils/1.png",
      "quality":["Souriant","Ponctuel","A l'écoute"]

    },
    {
      "idPrestataire":2,
      "firstName":"Mathias",
      "job":"Déménageur",
      "rate":4.75,
      "nbReviews":159,
      "hourlyPrice":25,
      "imgProfile":"/assets/profils/2.jpg",
      "quality":["Souriant","Ponctuel","A l'écoute"]

    },
    {
      "idPrestataire":3,
      "firstName":"Thomas",
      "job":"Bricoleur",
      "rate":4.58,
      "nbReviews":159,
      "hourlyPrice":25,
      "imgProfile":"/assets/profils/3.jpg",
      "quality":["Souriant","Ponctuel","A l'écoute"]

    },
    {
      "idPrestataire":4,
      "firstName":"Ludivine",
      "job":"Baby-sitter",
      "rate":4.58,
      "nbReviews":159,
      "hourlyPrice":25,
      "imgProfile":"/assets/profils/4.jpg",
      "quality":["Souriant","Ponctuel","A l'écoute"]

    },
    {
      "idPrestataire":5,
      "firstName":"Clémence",
      "job":"Pet-sitter",
      "rate":4.58,
      "nbReviews":159,
      "hourlyPrice":25,
      "imgProfile":"/assets/profils/5.jpg",
      "quality":["Souriant","Ponctuel","A l'écoute"]

    },
    {
      "idPrestataire":6,
      "firstName":"Yanis",
      "job":"Bricoleur",
      "rate":4.58,
      "nbReviews":159,
      "hourlyPrice":25,
      "imgProfile":"/assets/profils/6.jpg",
      "quality":["Souriant","Ponctuel","A l'écoute"]

    },
    {
      "idPrestataire":7,
      "firstName":"Sarah",
      "job":"Jardinier",
      "rate":4.58,
      "nbReviews":159,
      "hourlyPrice":25,
      "imgProfile":"/assets/profils/7.jpg",
      "quality":["Souriant","Ponctuel","A l'écoute"]

    },
    {
      "idPrestataire":8,
      "firstName":"Vincent",
      "job":"Jardinier",
      "rate":4.58,
      "nbReviews":159,
      "hourlyPrice":25,
      "imgProfile":"/assets/profils/8.jpg",
      "quality":["Souriant","Ponctuel","A l'écoute"]

    }

]
  